/**
 * TariffSelector Component
 *
 * Reusable dropdown for selecting an alternative tariff to compare against
 * the current fixed rate. Used across Tariff Comparison, Battery, and Solar tabs.
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { TARIFF_OPTIONS } from '@/hooks/useTariffComparison'

export default function TariffSelector({ value, onChange }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[220px] h-8 text-xs">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {TARIFF_OPTIONS.map(opt => (
          <SelectItem key={opt.value} value={opt.value} className="text-xs">
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
